import { httpGetManagerWorkers } from "../../Urls";
import ManagerWorkersHelper from "../../common/ManagerWorkersHelper";
import {
  updateManagerWorkers,
  updateSelectedWorkersIds,
  updateSelectedWorkersObjects,
  updateSelectedProjectsIds,
  updateSelectedProjectsObjects,
  updateStartDate,
  updateEndDate,
  updateAllDates,
  updateAllDatesEnabled,
  updateIsShowingWorkers,
  updateAllFuture,
  updateSelectedAuditOption,
  updateAllSelected,
  updateWorkers,
  updateProjects,
} from "../actions";
import { batchActions } from "redux-batched-actions";
import * as actionTypes from "../actionTypes";

export const FILTERS_ACTIONS = {
  INITIALIZE_FILTERS: "FILTERS/INITIALIZE_FILTERS",
  FETCH_MANAGER_WORKERS: "FILTERS/FETCH_MANAGER_WORKERS",
  UPDATE_DATES_AND_WORKERS: "FILTERS/UPDATE_DATES_AND_WORKERS",
  CLEAR_FILTER_STATE: "FILTERS/CLEAR_FILTER_STATE",
  SELECT_WORKERS: "FILTERS/SELECT_WORKERS",
  SELECT_PROJECTS: "FILTERS/SELECT_PROJECTS",
  MAP_PROJECTS_TO_ALL_SELECTED: "FILTERS/MAP_PROJECTS_TO_ALL_SELECTED",
  UPDATE_SELECTED_PROJECTS_OBJECTS: "FILTERS/UPDATE_SELECTED_PROJECTS_OBJECTS",
};

const checkIfExists = (props, state) => {
  if (!props || !props.selectedProjectsObjects) {
    return false;
  }
  const isArray = Array.isArray(props.selectedProjectsObjects);
  const len = props.selectedProjectsObjects.length;
  return (
    !isArray ||
    (isArray &&
      len === 1 &&
      state.projects.userProjects.find(
        (proj) => proj.ID === props.selectedProjectsObjects[0].value
      ))
  );
};

const inFreeDays = (value) => {
  return value >= 1001 && value <= 1005;
};

export const dataTransformers = {
  mapWorkers: (workers, currentUser) => {
    return workers.map((worker) => ({
      label: worker.EngName,
      value: worker.Id,
      selected: worker.Id.toLowerCase() === currentUser.userName,
    }));
  },

  mapProjects: (projects) => {
    return projects.map((project) => ({
      label: project.Name,
      value: project.ID,
      selected: project.ID === projects[0].ID,
    }));
  },

  mapProjectsToAllSelected: (projects) => {
    const mappedProjs = projects.map((proj) => ({
      label: proj.Name,
      value: proj.ID,
      selected: true,
    }));
    const projIds = projects.map((proj) => proj.ID);
    return { mappedProjs, projIds };
  },
};

export const apiUtils = {
  async getManagerWorkers(startDate, endDate) {
    const resp = await httpGetManagerWorkers(startDate, endDate);
    if (resp.status === 200) {
      const data = await resp.json();
      if (data.length > 0) {
        return new ManagerWorkersHelper(data);
      }
    }
    return null;
  },
};

export const localStorageUtils = {
  saveFilterState: (state) => {
    localStorage.setItem("startDate", state.startDate);
    localStorage.setItem("endDate", state.endDate);
    localStorage.setItem("allDates", state.allDates);
    localStorage.setItem("allDatesEnabled", state.allDatesEnabled);
    localStorage.setItem(
      "selectedWorkersIds",
      JSON.stringify(state.selectedWorkersIds)
    );
    localStorage.setItem(
      "selectedWorkersObjects",
      JSON.stringify(state.selectedWorkersObjects)
    );
    localStorage.setItem(
      "selectedProjectsIds",
      JSON.stringify(state.selectedProjectsIds)
    );
    localStorage.setItem(
      "selectedProjectsObjects",
      JSON.stringify(state.selectedProjectsObjects)
    );
    localStorage.setItem("isShowingWorkers", state.isShowingWorkers);
    localStorage.setItem("allFuture", state.allFuture);
    localStorage.setItem(
      "selectedAuditOption",
      JSON.stringify(state.selectedAuditOption)
    );
  },

  loadFilterState: () => {
    const state = {};
    if (localStorage.getItem("startDate")) {
      state.startDate = localStorage.getItem("startDate");
      state.endDate = localStorage.getItem("endDate");
      state.allDates = localStorage.getItem("allDates") === "true";
      state.allDatesEnabled =
        localStorage.getItem("allDatesEnabled") === "true";
      state.selectedWorkersIds = JSON.parse(
        localStorage.getItem("selectedWorkersIds")
      );
      state.selectedWorkersObjects = JSON.parse(
        localStorage.getItem("selectedWorkersObjects")
      );
      state.selectedProjectsIds = JSON.parse(
        localStorage.getItem("selectedProjectsIds")
      );
      state.selectedProjectsObjects = JSON.parse(
        localStorage.getItem("selectedProjectsObjects")
      );
      state.isShowingWorkers =
        localStorage.getItem("isShowingWorkers") === "true";
      state.allFuture = localStorage.getItem("allFuture") === "true";
      state.selectedAuditOption = JSON.parse(
        localStorage.getItem("selectedAuditOption")
      );
    }
    return state;
  },

  clearFilterState: () => {
    localStorage.removeItem("startDate");
    localStorage.removeItem("endDate");
    localStorage.removeItem("allDates");
    localStorage.removeItem("allDatesEnabled");
    localStorage.removeItem("selectedWorkersIds");
    localStorage.removeItem("selectedWorkersObjects");
    localStorage.removeItem("selectedProjectsIds");
    localStorage.removeItem("selectedProjectsObjects");
    localStorage.removeItem("isShowingWorkers");
    localStorage.removeItem("allFuture");
    localStorage.removeItem("selectedAuditOption");
  },
};

export const urlUtils = {
  loadFromUrlParams: () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const params = {};

    const startDate = urlParams.get("startDate");
    const endDate = urlParams.get("endDate");
    const employeeId = urlParams.get("employeeId");

    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }
    if (employeeId) {
      params.selectedWorkersIds = [employeeId];
    }

    window.history.pushState(null, "", window.location.href.split("?")[0]);

    return params;
  },
};

export const filtersMiddleware = (store) => (next) => (action) => {
  const state = store.getState();

  switch (action.type) {
    case FILTERS_ACTIONS.INITIALIZE_FILTERS: {
      const user = window.user;

      const localStorageState = localStorageUtils.loadFilterState();
      if (Object.keys(localStorageState).length > 0) {
        store.dispatch(
          batchActions([
            updateStartDate(localStorageState.startDate),
            updateEndDate(localStorageState.endDate),
            updateAllDates(localStorageState.allDates),
            updateAllDatesEnabled(localStorageState.allDatesEnabled),
            updateSelectedWorkersIds(localStorageState.selectedWorkersIds),
            updateSelectedWorkersObjects(
              localStorageState.selectedWorkersObjects
            ),
            updateSelectedProjectsIds(localStorageState.selectedProjectsIds),
            updateSelectedProjectsObjects(
              localStorageState.selectedProjectsObjects
            ),
            updateIsShowingWorkers(localStorageState.isShowingWorkers),
            updateAllFuture(localStorageState.allFuture),
            updateSelectedAuditOption(localStorageState.selectedAuditOption),
          ])
        );
        localStorageUtils.clearFilterState();
      }

      const urlParams = urlUtils.loadFromUrlParams();
      if (urlParams.startDate) {
        store.dispatch(updateStartDate(urlParams.startDate));
      }
      if (urlParams.endDate) {
        store.dispatch(updateEndDate(urlParams.endDate));
      }
      if (urlParams.selectedWorkersIds) {
        store.dispatch(updateSelectedWorkersIds(urlParams.selectedWorkersIds));
      }

      if (
        !state.workers.selectedWorkersIds ||
        !state.workers.selectedWorkersIds[0]
      ) {
        store.dispatch(
          batchActions([
            updateSelectedWorkersIds([user.userName]),
            updateSelectedWorkersObjects([
              {
                label: user.profile.name,
                value: user.userName,
              },
            ]),
            updateSelectedProjectsIds([-1]),
          ])
        );
      }

      if (state.workers.managerWorkers.length === 0) {
        store.dispatch({
          type: FILTERS_ACTIONS.FETCH_MANAGER_WORKERS,
          payload: {
            startDate: state.dates.startDate,
            endDate: state.dates.endDate,
          },
        });
      }

      break;
    }

    case FILTERS_ACTIONS.FETCH_MANAGER_WORKERS: {
      const { startDate, endDate } = action.payload;

      apiUtils.getManagerWorkers(startDate, endDate).then((managerWorkers) => {
        if (managerWorkers) {
          store.dispatch(updateManagerWorkers(managerWorkers));

          const workers = dataTransformers.mapWorkers(
            managerWorkers.Workers,
            window.user
          );
          store.dispatch(updateWorkers(workers));

          if (
            state.workers.selectedWorkersIds.length > 0 &&
            state.workers.selectedWorkersObjects.length === 0
          ) {
            const empsObj = workers.find(
              (w) => w.value === state.workers.selectedWorkersIds[0]
            );
            if (empsObj) {
              store.dispatch(updateSelectedWorkersObjects([empsObj]));
            }
          }
        }
      });

      break;
    }

    case FILTERS_ACTIONS.UPDATE_DATES_AND_WORKERS: {
      const { startDate, endDate } = action.payload;
      const user = window.user;
      apiUtils.getManagerWorkers(startDate, endDate).then((managerWorkers) => {
        if (managerWorkers) {
          const managerWorkersIds = managerWorkers.Workers.map((w) => w.Id);
          const selectedWorkersIds = state.workers.selectedWorkersIds.filter(
            (workerId) => managerWorkersIds.indexOf(workerId) !== -1
          );

          const workers = Array.isArray(state.workers.selectedWorkersObjects)
            ? state.workers.selectedWorkersObjects
            : [state.workers.selectedWorkersObjects];

          let selectedWorkersObjects;
          if (workers[0] && workers[0].value === "*") {
            const allWorkers = managerWorkers.Workers;
            selectedWorkersObjects = allWorkers.map((worker) => ({
              label: worker.EngName,
              value: worker.Id,
              selected: true,
            }));
            selectedWorkersObjects = [
              { label: "Select all", value: "*", selected: true },
              ...selectedWorkersObjects,
            ];
          } else {
            selectedWorkersObjects = workers.filter(
              (worker) =>
                managerWorkersIds.findIndex(
                  (id) => worker.value.toLowerCase() === id.toLowerCase()
                ) !== -1
            );
          }

          if (selectedWorkersIds.length === 0) {
            selectedWorkersIds.push(user.userName);
          }
          if (selectedWorkersObjects.length === 0) {
            selectedWorkersObjects = [
              {
                label: user.profile.name,
                value: user.userName,
                selected: true,
              },
            ];
          }

          store.dispatch(
            batchActions([
              updateManagerWorkers(managerWorkers),
              updateSelectedWorkersIds(selectedWorkersIds),
              updateSelectedWorkersObjects(selectedWorkersObjects),
              updateStartDate(startDate),
              updateEndDate(endDate),
            ])
          );
        }
      });

      break;
    }

    case FILTERS_ACTIONS.SELECT_WORKERS: {
      const { selectedWorkers } = action.payload;
      let workers;

      if (selectedWorkers === null) {
        workers = [];
      } else if (!Array.isArray(selectedWorkers)) {
        workers = [selectedWorkers.value];
      } else {
        const workersWithoutAll = [...selectedWorkers];
        if (selectedWorkers[0] && selectedWorkers[0].label === "Select all") {
          workersWithoutAll.shift();
        }
        workers = workersWithoutAll.map((worker) => worker.value);
      }

      if (!workers) {
        workers = [];
      }

      store.dispatch(
        batchActions([
          updateSelectedWorkersObjects(selectedWorkers),
          updateSelectedWorkersIds(workers),
        ])
      );

      break;
    }

    case FILTERS_ACTIONS.SELECT_PROJECTS: {
      let { selectedProjects } = action.payload;
      const { allProjects } = action.payload;
      let projects;

      if (selectedProjects === null) {
        projects = [];
      } else if (!Array.isArray(selectedProjects)) {
        projects = [selectedProjects.value];
      } else {
        const diff = state.projects.projects.filter(
          (firstObj) =>
            !selectedProjects.some(
              (secondObj) => firstObj.value === secondObj.value
            )
        );

        if (diff.length === 1 && allProjects) {
          selectedProjects = diff;
        }

        if (diff.length === 0) {
          store.dispatch(updateAllSelected(true));
        } else {
          store.dispatch(updateAllSelected(false));
        }

        projects = selectedProjects.map((project) => project.value);
      }

      if (!projects) {
        projects = [];
      }

      store.dispatch(
        batchActions([
          updateSelectedProjectsObjects(selectedProjects),
          updateSelectedProjectsIds(projects),
        ])
      );

      break;
    }

    case FILTERS_ACTIONS.MAP_PROJECTS_TO_ALL_SELECTED: {
      const { managerProjects } = action.payload;
      const projects = managerProjects || state.projects.managerProjects;
      const { mappedProjs, projIds } =
        dataTransformers.mapProjectsToAllSelected(projects);

      store.dispatch(
        batchActions([
          updateSelectedProjectsObjects(mappedProjs),
          updateSelectedProjectsIds(projIds),
          updateAllSelected(true),
        ])
      );

      break;
    }

    case FILTERS_ACTIONS.CLEAR_FILTER_STATE: {
      localStorageUtils.clearFilterState();
      break;
    }

    case actionTypes.UPDATE_MANAGER_WORKERS: {
      const newState = store.getState();
      if (
        newState.workers.managerWorkers &&
        newState.workers.managerWorkers.Workers
      ) {
        const workers = dataTransformers.mapWorkers(
          newState.workers.managerWorkers.Workers,
          window.user
        );
        store.dispatch(updateWorkers(workers));
      }
      break;
    }

    case actionTypes.UPDATE_MANAGER_PROJECTS: {
      const newState = store.getState();
      if (newState.projects.managerProjects) {
        const projects = dataTransformers.mapProjects(
          newState.projects.managerProjects
        );
        store.dispatch(updateProjects(projects));
      }
      break;
    }

    case actionTypes.UPDATE_USER_PROJECTS: {
      const newState = store.getState();
      if (newState.projects.userProjects) {
        const projects = dataTransformers.mapProjects(
          newState.projects.userProjects
        );
        store.dispatch(updateProjects(projects));
      }
      break;
    }

    case actionTypes.UPDATE_CURRENT_PAGE: {
      const newState = store.getState();
      const currentPage = action.page;
      const selectedProjectsObjects = newState.projects.selectedProjectsObjects;

      if (currentPage === "Hours") {
        const isArray = Array.isArray(selectedProjectsObjects);
        const len = isArray ? selectedProjectsObjects.length : null;

        const shouldReset =
          selectedProjectsObjects === null ||
          (isArray && len === 0 && !newState.workers.isShowingWorkers) ||
          (isArray &&
            len > 0 &&
            selectedProjectsObjects[0].label === "Select all") ||
          (!newState.workers.isShowingWorkers && isArray && len > 1) ||
          !checkIfExists(
            {
              selectedProjectsObjects,
              userProjects: newState.projects.userProjects,
            },
            newState
          );

        if (shouldReset) {
          store.dispatch(
            batchActions([
              updateSelectedProjectsObjects({
                label: "Select Project",
                selected: true,
                value: -1,
              }),
              updateSelectedProjectsIds([-1]),
              updateAllDates(false),
              updateAllDatesEnabled(false),
            ])
          );
        }
      } else if (currentPage === "Dashboard") {
        if (
          selectedProjectsObjects &&
          (selectedProjectsObjects.value === -1 ||
            inFreeDays(selectedProjectsObjects.value))
        ) {
          store.dispatch({
            type: FILTERS_ACTIONS.MAP_PROJECTS_TO_ALL_SELECTED,
            payload: { managerProjects: newState.projects.managerProjects },
          });
        }
      }
      break;
    }

    case actionTypes.UPDATE_SELECTED_PROJECTS_OBJECTS: {
      const newState = store.getState();
      const selectedProjectsObjects = newState.projects.selectedProjectsObjects;
      const currentPage = newState.general.currentPage;

      const isArray = Array.isArray(selectedProjectsObjects);
      if (
        (currentPage !== "Planner" &&
          isArray &&
          selectedProjectsObjects.length === 1 &&
          selectedProjectsObjects[0].value === "*") ||
        (currentPage === "Dashboard" &&
          !isArray &&
          selectedProjectsObjects &&
          selectedProjectsObjects.value === -1)
      ) {
        store.dispatch({
          type: FILTERS_ACTIONS.MAP_PROJECTS_TO_ALL_SELECTED,
        });
      }
      break;
    }

    default:
      return next(action);
  }

  return next(action);
};

export default filtersMiddleware;
